var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 398,
    viewBox: "0 0 224 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5215_84665)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5215_84665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 224,
    height: 398
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 0H0V398H224V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5215_84665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.884 397.807C173.676 397.807 223.768 392.242 223.768 385.376C223.768 378.51 173.676 372.944 111.884 372.944C50.0922 372.944 0 378.51 0 385.376C0 392.242 50.0922 397.807 111.884 397.807Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.557 274.695C222.557 336.153 172.736 385.974 111.278 385.974C49.821 385.974 0 336.153 0 274.695C0 239.902 15.9686 208.837 40.9769 188.432C72.9233 158.562 49.716 148.463 87.7798 92.1444C125.45 36.4081 159.244 66.8981 155.168 95.8343C148.453 143.511 168.471 175.411 181.968 187.984C210.531 214.59 222.557 239.902 222.557 274.695Z",
    fill: "#CBE81B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.903 196.624C175.658 181.768 169.637 175.553 157.694 145.258C134.001 142.539 114.713 155.55 107.59 174.194C99.5017 195.362 110.988 215.656 117.688 221.774C119.671 223.585 120.504 224.687 126.33 228.668C135.808 235.145 147.218 247.991 151.674 258.964C176.24 319.458 131.379 360.331 100.792 366.843C60.2039 375.485 30.4951 357.619 14.1778 329.168C37.6764 371.213 78.9445 383.961 101.763 385.584C165.947 390.148 196.337 350.239 208.504 329.265C233.627 285.958 226.993 231.794 190.903 196.624Z",
    fill: "#C0D921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.222 24.4138C152.873 34.1992 153.527 48.0148 150.978 58.2284C161.625 62.8878 174.408 61.8342 178.119 60.9591C193.644 57.2983 205.824 45.1567 218.68 13.5379C188.28 22.2621 178.714 9.76595 163.222 24.4138Z",
    fill: "#CBE81B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.894 34.7356C143.54 40.5376 141.648 46.9417 141.648 52.0313C136.202 52.9702 130.429 50.9791 128.818 50.1341C122.08 46.5987 117.861 39.4772 115.572 23.1398C128.587 30.7921 134.437 26.0505 139.894 34.7356Z",
    fill: "#CBE81B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5215_84665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 398,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.382be6388113453affd0bec26741f581.svg";
export { ForwardRef as ReactComponent };